import { NgClass } from '@angular/common';
import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'qb-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  imports: [NgClass, MatProgressSpinner],
})
export class LoadingComponent implements OnInit {
  @Input() data: any;
  @Input() size: number;
  /** Positioned sets the loader 100+px from the top of the container.  */
  positioned = true;

  // Have to put this here to check if data is an array
  Array = Array;

  constructor(private element: ElementRef) {}

  ngOnInit(): void {
    // This makes sure that there is no positioning done to the loader if we've set a custom size.
    this.positioned = this.size === undefined;
    this.size = this.size ?? 100;
  }
}
